import { applyMiddleware, compose, createStore } from "redux";
import thunkMiddleware from "redux-thunk";

import rootReducer from "./reducers/root-reducer";

const enhancers = [];
if (process.env.NODE_ENV !== "production") {
  const { __REDUX_DEVTOOLS_EXTENSION__ } = window;
  if (typeof __REDUX_DEVTOOLS_EXTENSION__ === "function") {
    enhancers.push(__REDUX_DEVTOOLS_EXTENSION__());
  }
}

const middlewareEnhancer = applyMiddleware(thunkMiddleware);
const composedEnhancers = compose(middlewareEnhancer, ...enhancers);
const store = createStore(rootReducer, undefined, composedEnhancers);
export default store;
